<template>
	<ActivityLayout class="goal-archive-activity">
		<template #badge>
			<ArchiveGoalActivityBadge
				:is-archived="activity.to"
			/>
		</template>
		<template #text>
			<p>{{ text }}</p>
		</template>
		<template #timestamp>{{ activity.changedAt }}</template>
	</ActivityLayout>
</template>

<script>
import ActivityLayout from "../Activity/ActivityLayout.vue";
import ArchiveGoalActivityBadge from "../Activity/ArchiveGoalActivityBadge.vue";

export default {
	name: "GoalArchiveActivity",
	components: {
		ActivityLayout,
		ArchiveGoalActivityBadge,
	},
	props: {
		/** { changedBy:String, changedAt:String, to:Boolean } */
		activity: {
			type: Object,
			required: true,
		},
	},
	computed: {
		text() {
			const { to, changedBy, } = this.activity;
			const key = to ? "archivedText" : "unarchivedText";
			return this.translate( key, { changedBy, } );
		},
	},
	methods: {
		translate( key, args = {} ) {
			return this.$t( `common-gokr.components.GoalArchiveActivity.${ key }`, args );
		},
	},
};
</script>

<style lang="scss" scoped>

</style>
